import { Routes } from '@angular/router';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
  path: '',
  component: LayoutComponent,
  children: [
    {
      path: '',
      loadComponent: () =>
        import('./features/home/home.component').then(m => m.HomeComponent),
    },
    {
      path: 'lista-productos',
      loadComponent: () =>
        import('./features/product-list/pages/list/list.component').then(m => m.ListComponent)
    },
    {
      path: 'lista-productos/productos-originales',
      loadComponent: () =>
        import('./features/product-list/pages/originals/originals.component').then(m => m.OriginalsComponent)
    },
    {
      path: 'lista-productos/:categoryId',
      loadComponent: () =>
        import('./features/product-list/pages/list/list.component').then(m => m.ListComponent)
    },
    {
      path: 'products/:id',
      loadComponent: () =>
        import('./features/product-list/pages/detail/detail.component')
          .then(m => m.DetailComponent)
    },
    {
      path: 'mi-cuenta',
      canActivate: [authGuard],
      loadComponent: () =>
        import('./features/account/pages/account/account.component')
          .then(m => m.AccountComponent)
    },
    {
      path: 'payment/:result',
      loadComponent: () =>
        import('./features/payment-result/payment-result.component')
          .then(m => m.PaymentResultComponent)
    },
    {
      path: 'info/:slug',
      loadComponent: () =>
        import('./features/info-page/info-page.component')
          .then(m => m.InfoPageComponent)
    }
  ]
},
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: '**',
    redirectTo: ''
  }

];
